import { Component, OnInit } from '@angular/core';
import {CustomerCareService} from '@api/customer-care.service';
import {
  IFirmwareHistoryByProductResponseBody
} from 'rsc-iot-cloud-lib-sdk/petsafe/products/firmware/history-by-product';

@Component({
  selector: 'app-smartdoor-help',
  templateUrl: './smartdoor-help.component.html',
  styleUrls: ['./smartdoor-help.component.scss']
})
export class SmartdoorHelpComponent implements OnInit {

  activityCodes: Array<{section: string, codes: Array<{code: string, description: string}>}> = [
    {
      section: 'Motion',
      codes: [
        {
          code: 'MOTION_DETECTED_INSIDE',
          description: 'Motion detected inside'
        },
        {
          code: 'MOTION_DETECTED_OUTSIDE',
          description: 'Motion present outside'
        },
        {
          code: 'MOTION_ABSENT_OUTSIDE',
          description: 'Motion absent outside'
        },
        {
          code: 'MOTION_ABSENT_INSIDE',
          description: 'Motion absent inside'
        },
        {
          code: 'MOTION_ABSENT_OUTSIDE_FALSE_TRIGGER',
          description: 'Motion absent outside no RFID read'
        },
        {
          code: 'MOTION_ABSENT_INSIDE_FALSE_TRIGGER',
          description: 'Motion absent inside no RFID read'
        },
      ]
    },
    {
      section: 'RFID read',
      codes: [
        {
          code: 'RFID_READ_INSIDE',
          description: 'RFID tag read inside'
        },
        {
          code: 'RFID_READ_OUTSIDE',
          description: 'RFID tag read outside'
        }
      ]
    },
    {
      section: 'Access Permission Lookup',
      codes: [
        {
          code: 'ACCESS_PERMISSION_LOOKUP',
          description: 'Permission Lookup Result'
        }
      ]
    },
    {
      section: 'Latch',
      codes: [
        {
          code: 'LATCH_LOCKED',
          description: 'Latch was locked'
        },
        {
          code: 'LATCH_UNLOCKED',
          description: 'Latch was unlocked'
        },
        {
          code: 'LATCH_IN_ONLY',
          description: 'Latch set to in-only'
        },
        {
          code: 'LATCH_OUT_ONLY',
          description: 'Latch set to out-only'
        },
      ]
    },
    {
      section: 'Flap Swing Movement',
      codes: [
        {
          code: 'FLAP_SWING_IN',
          description: 'Flap Swing in'
        },
        {
          code: 'FLAP_SWING_OUT',
          description: 'Flap Swing out'
        },
        {
          code: 'FLAP_SWING_TIMEOUT',
          description: 'Flap Swing timeout'
        },
        {
          code: 'FLAP_CENTERED',
          description: 'Flap centered'
        },
      ]
    },
    {
      section: 'Pet',
      codes: [
        {
          code: 'PET_ENTERED',
          description: 'Pet Entered'
        },
        {
          code: 'PET_EXITED',
          description: 'Pet Exited'
        },
        {
          code: 'PET_FAILED_TO_TRANSIT_DOOR_RELOCKED',
          description: 'Pet read did not exit or enter in the specified time'
        }
      ]
    },
    {
      section: 'User Initiated Activity',
      codes: [
        {
          code: 'USER_MODE_CHANGE_SMART',
          description: 'User changed mode to smart'
        },
        {
          code: 'USER_MODE_CHANGE_LOCKED',
          description: 'User changed mode to locked'
        },
        {
          code: 'USER_MODE_CHANGE_UNLOCKED',
          description: 'User changed mode to unlocked'
        },
        {
          code: 'USER_DISABLED_FRONT_PANEL',
          description: 'User disabled front panel'
        },
        {
          code: 'USER_WIFI_SOFT_REBOOT',
          description: 'User reset WiFi'
        },
        {
          code: 'USER_WIFI_PROVISIONING_RESET',
          description: 'User reset provisioning'
        },
        {
          code: 'USER_FACTORY_RESET',
          description: 'User factory reset'
        },
        {
          code: 'USER_BUTTONS_LOCKED_ENABLED',
          description: 'User buttons lock enabled'
        },
        {
          code: 'USER_BUTTONS_LOCKED_DISABLED',
          description: 'User buttons lock disabled'
        },
      ]
    },
    {
      section: 'Cloud Initiated Activity',
      codes: [
        {
          code: 'CLOUD_MODE_CHANGE_SMART',
          description: 'Cloud changed mode to smart'
        },
        {
          code: 'CLOUD_MODE_CHANGE_LOCKED',
          description: 'Cloud changed mode to locked'
        },
        {
          code: 'CLOUD_MODE_CHANGE_UNLOCKED',
          description: 'Cloud changed mode to unlocked'
        },
        {
          code: 'CLOUD_BUTTONS_LOCKED_ENABLED',
          description: 'Cloud buttons lock enabled'
        },
        {
          code: 'CLOUD_BUTTONS_LOCKED_DISABLED',
          description: 'Cloud buttons lock disabled'
        }
      ]
    },
    {
      section: 'Display',
      codes: [
        {
          code: 'DISPLAY_ON',
          description: 'Display on'
        },
        {
          code: 'DISPLAY_OFF',
          description: 'Display off'
        },
      ]
    },
    {
      section: 'Errors',
      codes: [
        {
          code: 'ERROR_MOTOR_OVERCURRENT',
          description: 'Motor overcurrent error'
        },
        {
          code: 'ERROR_MOTOR_TIMEOUT',
          description: 'Motor timeout error'
        },
        {
          code: 'ERROR_FLAP_TIMEOUT',
          description: 'Flap timeout'
        },
        {
          code: 'ERROR_FLAP_STUCK',
          description: 'Flap stuck'
        },
        {
          code: 'ERROR_INSIDE_MOTION_SENSOR_CONTINUOUS',
          description: 'Inside Motion Sensor Invalid Error'
        },
        {
          code: 'ERROR_OUTSIDE_MOTION_SENSOR_CONTINUOUS',
          description: 'Outside Motion Sensor Invalid Error'
        },
        {
          code: 'ERROR_BUTTON_STUCK',
          description: 'Button Stuck Error (WiFi, Smart Mode, Lock/Unlock Toggle)'
        },
        {
          code: 'ERROR_LATCH_POSITION_SENSOR',
          description: 'Latch Position Sensor Error'
        },
        {
          code: 'ERROR_VOLTAGE_READING_OUT_OF_RANGE',
          description: 'Voltage Reading Error (i.e. reading 0)'
        },
      ]
    },
    {
      section: 'RTC Time Update',
      codes: [
        {
          code: 'RTC_TIME_UPDATE',
          description: 'RTC Time Update'
        }
      ]
    },
    {
      section: 'Battery',
      codes: [
        {
          code: 'POWER_FAIL_MODE',
          description: 'Setting door to power fail mode (battery)'
        },
        {
          code: 'BATTERY_LEVEL_THRESHOLD',
          description: 'Battery level threshold has been crossed'
        },
      ]
    },
    {
      section: 'AC Power',
      codes: [
        {
          code: 'POWER_AC_LOST',
          description: 'AC power lost'
        },
        {
          code: 'POWER_AC_RESTORED',
          description: 'AC power restored'
        },
        {
          code: 'POWER_AC_NO_BATTERIES',
          description: 'No batteries installed and on AC'
        },
      ]
    },
    {
      section: 'Final Act',
      codes: [
        {
          code: 'ENTERED_FINAL_ACT_STATE',
          description: 'Entered final act state'
        },
        {
          code: 'EXITED_FINAL_ACT_STATE',
          description: 'Exited final act state'
        },
      ]
    },
    {
      section: 'OTA Update Actions',
      codes: [
        {
          code: 'OTA_WAITING_JOB_START',
          description: 'Waiting for OTA job'
        },
        {
          code: 'OTA_JOB_STARTED',
          description: 'Starting OTA job'
        },
        {
          code: 'OTA_BLOCK_RECEIVED',
          description: 'Block received during OTA'
        },
        {
          code: 'OTA_ALL_BLOCKS_RECEIVED',
          description: 'All OTA blocks received'
        },
        {
          code: 'OTA_IMAGE_VERIFIED',
          description: 'OTA image verified'
        },
      ]
    }
  ];

  mediumFirmwareHistory: IFirmwareHistoryByProductResponseBody = [];
  largeFirmwareHistory: IFirmwareHistoryByProductResponseBody = [];

  constructor(private customerCareService: CustomerCareService) { }

  ngOnInit() {
    this.customerCareService.getFirmwareHistoryByProduct({productType: 'smartdoor_medium'}).subscribe(
      (response) => {
        this.mediumFirmwareHistory = response;
      }, (error) => {console.log(error); }
    );
    this.customerCareService.getFirmwareHistoryByProduct({productType: 'smartdoor_large'}).subscribe(
      (response) => {
        this.largeFirmwareHistory = response;
      }, (error) => {console.log(error); }
    );
  }

}
